<template>
  <div class="conference-item__details">
    <h2 class="conference-item__details-heading">
      At a glance
    </h2>

    <dl class="conference-item__details-list">
      <div v-if="firstSessionStartDate">
        <dt class="conference-item__definition">
          Date
        </dt>
        <dd>
          {{ firstSessionStartDate }}
        </dd>
      </div>

      <div v-if="timeRange">
        <dt class="conference-item__definition">
          Time
        </dt>
        <dd>
          {{ timeRange }}
        </dd>
      </div>

      <dt class="conference-item__definition">
        Bookings Close
      </dt>
      <dd>
        {{ bookingClosedDate }}
      </dd>
      <template v-if="marketingLocation">
        <dt class="conference-item__definition">
          Location
        </dt>
        <dd>
          {{ marketingLocation }}
        </dd>
      </template>
    </dl>

    <div class="social-media">
      <span class="social-media__heading">
        Share this on:
      </span>

      <div class="social-media__links">
        <vue-goodshare-facebook has_icon></vue-goodshare-facebook>
        <vue-goodshare-x-twitter has-icon></vue-goodshare-x-twitter>
        <vue-goodshare-linked-in has_icon></vue-goodshare-linked-in>
        <vue-goodshare-email has_icon></vue-goodshare-email>
      </div>
    </div>
  </div>
</template>
<script>
import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
import VueGoodshareLinkedIn from "vue-goodshare/src/providers/LinkedIn.vue";
import VueGoodshareEmail from "vue-goodshare/src/providers/Email.vue";
import VueGoodshareXTwitter from "~/Components/SocialShare/XTwitter.vue";

export default {
  name: "ConferenceDetails",
  components: {
    VueGoodshareEmail,
    VueGoodshareLinkedIn,
    VueGoodshareFacebook,
    VueGoodshareXTwitter,
  },
  props: {
    marketingLocation: {
      type: String,
      default: null,
    },
    firstSessionStartDate: {
      type: String,
      default: null,
    },
    bookingClosedDate: {
      type: String,
      default: null,
    },
    timeRange: {
      type: String,
      default: null,
    },
  },
};
</script>
<style lang="less" scoped>
  @import "../../Styles/critical/courseItem.less";
</style>
